import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  TextField,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Box,
  Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const CreateTodoList = ({
  isCreating,
  newListName,
  onNameChange,
  onCreateList,
  onCancel,
  onStartCreating,
  classes,
  isEditing = false,
  currentDescription = '',
}) => {
  const [description, setDescription] = useState(currentDescription);
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
    if (isEditing) {
      setDescription(currentDescription);
    }
  };

  const handleClose = () => {
    setOpen(false);
    setDescription('');
    onCancel();
  };

  const handleSave = () => {
    onCreateList(description);
    setOpen(false);
    setDescription('');
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      if (newListName.trim() !== '') {
        handleSave();
      }
    }
  };

  return (
    <div className={classes.createListContainer}>
      {!isEditing && (
        <Button 
          variant="contained" 
          color="primary" 
          onClick={handleOpen}
          sx={{ mb: 2 }}
        >
          Create New List
        </Button>
      )}

      <Dialog 
        open={open || isCreating} 
        onClose={handleClose}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant="h6">
              {isEditing ? 'Edit List' : 'Create New List'}
            </Typography>
            <IconButton
              edge="end"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent>
          <Box sx={{ mt: 2 }}>
            <TextField
              autoFocus
              fullWidth
              label="List Name"
              value={newListName}
              onChange={onNameChange}
              onKeyDown={handleKeyDown}
              margin="normal"
              required
              error={newListName.trim() === ''}
              helperText={newListName.trim() === '' ? 'List name is required' : ''}
            />
            <TextField
              fullWidth
              label="Description"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              onKeyDown={handleKeyDown}
              margin="normal"
              multiline
              rows={3}
              placeholder="Add a description for this list (optional)"
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button 
            onClick={handleSave}
            variant="contained"
            color="primary"
            disabled={newListName.trim() === ''}
          >
            {isEditing ? 'Save Changes' : 'Create List'}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

CreateTodoList.propTypes = {
  isCreating: PropTypes.bool.isRequired,
  newListName: PropTypes.string.isRequired,
  onNameChange: PropTypes.func.isRequired,
  onCreateList: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onStartCreating: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  isEditing: PropTypes.bool,
  currentDescription: PropTypes.string,
};

CreateTodoList.defaultProps = {
  isEditing: false,
  currentDescription: '',
};

export default CreateTodoList;
